export enum AuthEnum{
    Login=1,
    SignUp,
    ForgetPassword,
    VerifyEmail
}